import * as React from 'react';
import { DocLayout } from 'src/layouts/DocLayout';
import { Layout } from 'antd';
import { RedocContainer } from 'src/containers/RedocContainer';

export class DocPage extends React.Component {  
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
            <RedocContainer/>
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DocPage/index.tsx